module.exports = __webpack_public_path__ + "static/img/test_qr_code_02.97e714c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test_qr_code_02.png
// module id = bkVM
// module chunks = 1